import { render, staticRenderFns } from "./benke.vue?vue&type=template&id=7b032e97&scoped=true"
import script from "./benke.vue?vue&type=script&lang=js"
export * from "./benke.vue?vue&type=script&lang=js"
import style0 from "./benke.vue?vue&type=style&index=0&id=7b032e97&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b032e97",
  null
  
)

export default component.exports